import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loading, MyExportCSV } from '.';
import { getAmenities, handleDeleteAmenty, handleViewAmenty } from '../features/PropertySettings/PropertySettingsSlice';
import { MdEdit } from 'react-icons/md';
import { AiFillEye } from 'react-icons/ai';
import { BsFillTrashFill } from 'react-icons/bs';
import {
  BootstrapTable,
  paginationFactory,
  ToolkitProvider,
  PaginationProvider,
  PaginationListStandalone,
} from '../utils/Table';
import Wrapper from '../assets/wrappers/Amenities';
import ConfirmModal from '../modals/ConfirmModal';
import icon from '../assets/images/edit-big.svg';
const Amenities = () => {
  // const [confirmModal, setConfirmModal] = useState(false);
  const dispatch = useDispatch();
  const { isLoading, amenities, currentPropertyType, isViewAmentyModalOpen, isEditAmentyModalOpen, isDeleteAmentyModalOpen } = useSelector(
    (store) => store.propertySettings
  );
  useEffect(() => {
    dispatch(getAmenities());
  }, []);

  const columns = [
    {
      dataField: 'title',
      text: 'title',
      sort: true,
    },

    {
      dataField: 'action',
      isDummyField: true,
      text: 'Action',
      formatter: (cellContent, row) => (
        <>
          <div className='d-flex gap-3'>
            <MdEdit />
            <AiFillEye />
            <BsFillTrashFill onClick={() => dispatch(handleDeleteAmenty(row))} />
          </div>
        </>
      ),
    },
  ];

  //pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    totalSize: amenities.length,
  };
  // sorting option
  const defaultSorted = [
    {
      dataField: 'title',
      order: 'asc',
    },
  ];

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Wrapper>
      <PaginationProvider pagination={paginationFactory(options)}>
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider keyField='id' data={amenities} columns={columns}>
            {(props) => (
              <>
                <div className='d-flex justify-content-end'>
                  <MyExportCSV {...props.csvProps} />
                  <button className='add-btn ms-2'>Add an Amenity</button>
                </div>
                <BootstrapTable
                  bordered={false}
                  hover
                  responsive
                  defaultSorted={defaultSorted}
                  {...props.baseProps}
                  {...paginationTableProps}
                />
                <div className='row'>
                  <div className='col pagination pagination-rounded justify-content-end '>
                    <PaginationListStandalone {...paginationProps} />
                  </div>
                </div>
              </>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>

      {isDeleteAmentyModalOpen && (
        <ConfirmModal
          setShow={() => dispatch(handleDeleteAmenty())}
          show={isDeleteAmentyModalOpen}
          title='Delete property Type'
          bodyText='Are you sure you want to delete this property Type ?'
          icon={icon}
          color='danger'
        />
      )}
    </Wrapper>
  );
};

export default Amenities;
